import React, { useEffect } from 'react';
import { AmplifyLogs, CodingConstants } from '@constants';
import { TaxDocumentProps } from '@components/types';
import { InfoModal } from 'fmc-digital-common';
import { logUserEvent } from '@analytics/amplifyLogging';
import { useDisclose } from 'native-base';
import { InfoJson } from './InfoJson';
import { Wrapper } from '@components/AlertModal/AlertModal.styled';
import { Tile, TileContextProvider } from '@fmc-digital/ui';
import { Tile1098 } from '@utils/tiles.data';

//TODO - need to move this to bundle offer template card
const TaxDocumentWidget: React.FC<TaxDocumentProps & { handleDocument: (docType: string, loanNumber: string) => void }> = ({
    loanNumber,
    themeType,
    id,
    handleDocument
}) => {
    const { taxDoc, turboTaxPopUp, taxDocumentWidget } = CodingConstants;
    const { isOpen, onClose, onToggle } = useDisclose(false);
    // const { handleDocument } = useContext(WidgetsContext);

    const handle1098Click = () => {
        handleDocument(taxDoc, loanNumber);
        const turboTaxStatus = window.localStorage.getItem('TurboTaxStatusOnWidget');
        if (turboTaxStatus !== 'shown') {
            onToggle();
            logUserEvent(AmplifyLogs.turboTaxPopupDisplayed);
        }
    };

    useEffect(() => {
        if (id === turboTaxPopUp) {
            const turboTaxStatus = window.localStorage.getItem('TurboTaxStatus');
            if (turboTaxStatus !== 'shown') {
                onToggle();
                logUserEvent(AmplifyLogs.turboTaxPopupDisplayedViaLogin);
            }
        }
    }, [id]);

    return (
        <>
            {isOpen ? (
                <Wrapper>
                    <InfoModal
                        data={InfoJson}
                        isOpen={isOpen}
                        onClose={() => {
                            if (id === turboTaxPopUp) {
                                window.localStorage.setItem('TurboTaxStatus', 'shown');
                                logUserEvent(AmplifyLogs.turboTaxPopupClosedViaLogin);
                            } else {
                                window.localStorage.setItem('TurboTaxStatusOnWidget', 'shown');
                                logUserEvent(AmplifyLogs.turboTaxPopupClosed);
                            }
                            onClose();
                        }}
                        handleTaxBtnClick={(url: string) => {
                            if (id === turboTaxPopUp) {
                                logUserEvent(AmplifyLogs.turboTaxPopupButtonClickedViaLogin);
                            } else {
                                logUserEvent(AmplifyLogs.turboTaxPopupButtonClicked);
                            }
                            window.open(url);
                        }}
                    />
                </Wrapper>
            ) : null}
            {id === taxDocumentWidget ? (
                <TileContextProvider
                    {...Tile1098}
                    onDeepLink={handle1098Click}
                    logUserEvent={event => console.log(event)}
                    key={`1098_tile_template_provider`}
                >
                    <Tile key={`1098_template_tile`} />
                </TileContextProvider>
            ) : null}
        </>
    );
};
export default React.memo(TaxDocumentWidget);
